// extracted by mini-css-extract-plugin
export default {"TeamMembersContainer":"TeamMembers_TeamMembersContainer__gDEhk","TeamMembersHeader":"TeamMembers_TeamMembersHeader__obPnE","TeamMembersBody":"TeamMembers_TeamMembersBody__fcgU7"};